import { Storage } from "@capacitor/storage";
import { useBillingData } from "@sushicorp/contexts";
import { useCatalogues } from "@sushicorp/contexts";
import { useGeo } from "@sushicorp/contexts";
import { usePayments } from "@sushicorp/contexts";
import { useProducts } from "@sushicorp/contexts";
import { useShippingAddress } from "@sushicorp/contexts";
import { useShoppingCart } from "@sushicorp/contexts";
import { useCountries } from "@sushicorp/contexts";
import { useVendors } from "@sushicorp/contexts";
import { useFetchUser } from "@sushicorp/services";
import { events } from "artisn/analytics";
import { signOut as signOutFirebase } from "firebase/auth";

import { getAuth } from "config/artisn.config";
import CONSTANTS from "config/constants";
import useAuth from "contexts/auth/auth.context.hooks";
import { notify } from "utils/common.utils";

const { STORAGE } = CONSTANTS;
const { BILLING_DATA_TOKEN } = STORAGE;
const { CATEGORY_TOKEN, SELECTED_COORDINATES_TOKEN, CARD_TOKEN } = STORAGE;
const { SHIPPING_ADDRESS_TOKEN, THEME_PREFERENCE_TOKEN } = STORAGE;
const { logSignOut } = events.auth;

const useSignOut = () => {
  const authContext = useAuth();
  const { resetBillingContext } = useBillingData();
  const { resetCataloguesContext } = useCatalogues();
  const { resetGeoContext } = useGeo();
  const { resetPaymentsContext } = usePayments();
  const { resetProductsContext } = useProducts();
  const { resetShoppingCartContext } = useShoppingCart();
  const { resetShippingAddressContext } = useShippingAddress();
  const { resetCountriesContext } = useCountries();
  const { resetVendorsContext } = useVendors();
  const { data: user } = useFetchUser(authContext, notify);

  const cleanLocalStorage = () => {
    const tokens = [
      SHIPPING_ADDRESS_TOKEN,
      BILLING_DATA_TOKEN,
      CATEGORY_TOKEN,
      THEME_PREFERENCE_TOKEN,
      SELECTED_COORDINATES_TOKEN,
      CARD_TOKEN
    ];
    tokens.forEach(token => {
      Storage.remove({
        key: token
      });
    });
  };

  const signOut = async () => {
    try {
      cleanLocalStorage();
      resetBillingContext();
      resetCataloguesContext();
      resetCountriesContext();
      resetGeoContext();
      resetPaymentsContext();
      resetProductsContext();
      resetShoppingCartContext();
      resetShippingAddressContext();
      resetVendorsContext();
      await signOutFirebase(getAuth);
      window.scrollTo(0, 0);
      logSignOut({ userId: user?.uid ?? "", name: user?.name ?? "" });
      window.location.reload();
    } catch (e) {
      console.error(e.message);
    }
  };

  return signOut;
};

export default useSignOut;
